import { mutator } from 'satcheljs';
import getStore from '../store/store';
import deleteProfile from '../actions/deleteProfile';

/**
 * Delete a profile from the store.
 */
export default mutator(deleteProfile, actionMessage => {
    let store = getStore();

    // The delete service command operates on itemId and not
    // serviceId. The internal data structures are all centered
    // around the serviceId.
    store.profiles.forEach(profile => {
        if (profile.ItemId.Id === actionMessage.itemId.Id) {
            const profileIdToDelete = profile.ServiceId;
            store.profiles.delete(profileIdToDelete);
            const index = store.profilesOrder.indexOf(profileIdToDelete);
            store.profilesOrder.splice(index, 1);
            return;
        }
    });
});
